import { render, staticRenderFns } from "./FormItemRadioWithTextArea.vue?vue&type=template&id=23dac277"
import script from "./FormItemRadioWithTextArea.vue?vue&type=script&lang=js"
export * from "./FormItemRadioWithTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports